import { LoanFile } from '../constants/loanFile';

/** "Awaiting Save" for a new file, "To be deleted" for one marked for deletion, otherwise "Saved". */
export const FileStatus = ({ file }: { file: LoanFile }) => {
    if (file.id === 0) {
        return <span style={{ color: 'orange' }}>Awaiting Save</span>;
    }
    if (file.isDeleted) {
        return <span style={{ color: 'darkred' }}>To be deleted</span>;
    }
    return <span style={{ color: 'darkgreen' }}>Saved</span>;
};
